export default __webpack_public_path__ + "static/media/cone.99866c60.gif";